import maintainRequest from "@/maintain/utils/maintainRequest";

export default function getAgentDeviceByPage(params, pageNum = 1, size = 10) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/getDeviceByPage/${pageNum}/${size}`,
    params: params,
  });
}
